module.exports = __webpack_public_path__ + "static/img/MZ.f13f8c7b.png";